module.exports = __webpack_public_path__ + "img/more-option.2d0476c0.svg";